import React from 'react';
import { Typography } from '@mui/material';
import PolicyHeader from './PolicyHeader';
import CommonMapFunction from './CommonMapFunction';
import { companyDetails } from 'utils/companyDetails';
import Policy from './Policy';
import {
  termDataOne,
  termDataTwo,
  termDataThree,
  termDataFour,
  termDataFive,
  termDataSix,
  termDataSeven,
  termDataEight,
  termDataNine,
} from './TermAndConditionData';

function TermAndCondition() {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {!isMobileParams && <PolicyHeader/>}
      <div className="aboutBackground">
      { !isMobileParams &&<Typography className="justifyCenter fw500 headerText pt20 pb30">
        {companyDetails?.companyName} - Terms and Conditions – Users
        </Typography>}
        <CommonMapFunction data={termDataOne} />
        <Policy policyData={termDataTwo} />
        <CommonMapFunction data={termDataThree} />
        <Policy policyData={termDataFour} subsection="term" />
        <CommonMapFunction data={termDataFive} />
        <Policy policyData={termDataSix} />
        <CommonMapFunction data={termDataSeven} />

        <div className="mb20">
          <Typography variant="head5" className="fw500">
            23. Updates to Terms & Conditions
          </Typography>
          <Typography variant="body2" className="fw400">
          {companyDetails?.companyName} reserves the right to update these Terms at any time.
            We will notify you of any changes by posting the revised Terms on
            the App and our website &nbsp;
            <span>
              <a href="https://iter.co.in/" target="_blank">
                https://iter.co.in/
              </a>
            </span>
          </Typography>
        </div>
        <Policy policyData={termDataEight} />
        <CommonMapFunction data={termDataNine} />
      </div>
    </div>
  );
}

export default TermAndCondition;
